<div [ngClass]="flexBoxClass()" [ngStyle]="style()">
  <ng-template flexBoxHost></ng-template>
</div>
